import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useOrderForceCloseoutCardViewModel = ({ id: orderId }) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [forceCompleteActivity, setForceCompleteActivity] = useState({});
  const [
    managerApprovalForceCompleteActivity,
    setManagerApprovalForceCompleteActivity,
  ] = useState({});

  const getForceCompleteActivity = () => {
    stateManager.run(async () => {
      const response = await taskService.activities.getAll({
        filters: {
          activityType: {
            eq: "ForceCompleteOrderForAccounting",
          },
        },
        params: {
          refId: `task-service/orders/${orderId}`,
        },
        enableCaching: true,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setForceCompleteActivity(response.data[0]);
      }
    });
  };

  const getManagerApprovalForceCompleteActivity = () => {
    stateManager.run(async () => {
      const response = await taskService.activities.getAll({
        filters: {
          activityType: {
            eq: "ManagerApprovalForceCompleteOrderForAccounting",
          },
        },
        params: {
          refId: `task-service/orders/${orderId}`,
        },
        enableCaching: true,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setManagerApprovalForceCompleteActivity(response.data[0]);
      }
    });
  };

  return {
    isLoading,
    getForceCompleteActivity,
    forceCompleteActivity,
    getManagerApprovalForceCompleteActivity,
    managerApprovalForceCompleteActivity,
  };
};
